module.exports = "/wwwroot/img/crisis_highlight_block.png?ver=3826e9dc";